import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommandeService } from 'src/app/core/services/commande.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-livraisons-livreur',
  templateUrl: './livraisons-livreur.component.html',
  styleUrls: ['./livraisons-livreur.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LivraisonsLivreurComponent implements OnInit {
  livreurId!: number;
  nomLivreur = '';

  indicateurChargement = true;
  messageErreur = '';

  statutSelectionne = 'ALL';
  dateDebut = '';
  dateFin = '';

  pageCourante = 1;
  taillePage = 10;
  totalElements = 0;
  totalPages = 1;
  indexDebut = 0;
  indexFin = 0;

  livraisons: any[] = [];

  readonly statuts = [
    { value: 'ALL', label: 'Tous les statuts' },
    { value: 'EN_ATTENTE', label: 'Commande enregistrée' },
    { value: 'EN_PREPARATION', label: 'En route vers le retrait' },
    { value: 'AFFECTE', label: 'Livreur assigné' },
    { value: 'EN_LIVRAISON', label: 'Colis en route' },
    { value: 'LIVRE', label: 'Livrée' },
    { value: 'ANNULE', label: 'Annulée' }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commandeService: CommandeService,
    private messageService: MessageService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.livreurId = Number(params['id']);
      if (!this.livreurId) {
        this.messageErreur = 'Identifiant livreur invalide.';
        return;
      }
      this.nomLivreur = this.route.snapshot.queryParamMap.get('nom') || '';
      this.chargerHistorique(1);
    });
  }

  chargerHistorique(page: number = this.pageCourante): void {
    this.pageCourante = page;
    this.indicateurChargement = true;
    this.messageErreur = '';

    const debutIso = this.dateDebut ? `${this.dateDebut}T00:00:00` : undefined;
    const finIso = this.dateFin ? `${this.dateFin}T23:59:59` : undefined;

    this.commandeService.obtenirHistoriqueLivreur(
      this.livreurId,
      this.pageCourante - 1,
      this.taillePage,
      this.statutSelectionne,
      debutIso,
      finIso
    ).subscribe({
      next: (res: any) => {
        const content = Array.isArray(res?.content) ? res.content : [];
        this.livraisons = content;
        this.totalElements = Number(res?.totalElements ?? content.length);
        const backendTotalPages = Number(res?.totalPages ?? 0);
        this.totalPages = backendTotalPages > 0 ? backendTotalPages : Math.max(1, Math.ceil(this.totalElements / this.taillePage));
        this.indexDebut = this.totalElements === 0 ? 0 : ((this.pageCourante - 1) * this.taillePage) + 1;
        this.indexFin = Math.min(this.pageCourante * this.taillePage, this.totalElements);
        this.indicateurChargement = false;
      },
      error: (err) => {
        this.indicateurChargement = false;
        this.messageErreur = this.messageService.afficherMessageErreur(err);
        this.toast.erreur(`Impossible de charger l'historique livreur : ${this.messageErreur}`);
      }
    });
  }

  appliquerFiltres(): void {
    if (this.dateDebut && this.dateFin && this.dateDebut > this.dateFin) {
      this.toast.erreur('La date de début doit être antérieure ou égale à la date de fin.');
      return;
    }
    this.chargerHistorique(1);
  }

  reinitialiserFiltres(): void {
    this.statutSelectionne = 'ALL';
    this.dateDebut = '';
    this.dateFin = '';
    this.chargerHistorique(1);
  }

  allerALaPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.pageCourante) {
      return;
    }
    this.chargerHistorique(page);
  }

  obtenirTexteStatut(statut: string): string {
    return this.statuts.find(s => s.value === statut)?.label || statut || '—';
  }

  obtenirClasseStatut(statut: string): string {
    const code = (statut || '').toUpperCase();
    if (code === 'LIVRE') return 'status-delivered';
    if (code === 'EN_LIVRAISON') return 'status-in-progress';
    if (code === 'AFFECTE' || code === 'EN_PREPARATION') return 'status-assigned';
    if (code === 'ANNULE') return 'status-cancelled';
    return 'status-pending';
  }

  voirDetailLivraison(livraison: any): void {
    const id = livraison?.id;
    if (!id) {
      this.toast.erreur('Impossible d’ouvrir le détail de cette livraison.');
      return;
    }
    this.router.navigate(['/commande', id]);
  }
}

